import { request } from 'src/shared/api';
import { apiRoutesMap } from 'src/shared/config';

export const createPromotion = (data: {
  title: string;
  start: string;
  finish: string;
}) => request.post<any>(apiRoutesMap.promotions.getRoute(), data);
